let sizeChangeDetected = false;

export const setSizeChangeFlag = () => {
  sizeChangeDetected = true;
};

export const consumeSizeChangeFlag = () => {
  const previousSizeChangeDetected = sizeChangeDetected;
  sizeChangeDetected = false;
  return previousSizeChangeDetected;
};
